import type { FC } from 'react';

import type { MainLayoutProps } from './types';

export const MainLayout: FC<MainLayoutProps> = ({ children }) => (
  <div className="relative flex h-full flex-col">{children}</div>
);
